import axios from 'config/axios';

export const fetchRiskAnualLoss = async (params) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_CRQ_RISK_ENDPOINT_URL}/getriskanualloss`,
        {
          params: params,
        }
      );
      return response
      
    } catch (error) {
      return error?.response?.data?.message;
    }
  };


export const fetchCategorizedRiskLosses = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRQ_RISK_ENDPOINT_URL}/getCategorizedRiskLosses`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};


export const fetchRiskScenarios = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRQ_RISK_ENDPOINT_URL}/getriskscenarios` ,
    {
    }
    );
    return response
  } catch (error) {
    return error?.response?.data?.message;
  }
};



export const fetchRiskLosses = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRQ_RISK_ENDPOINT_URL}/getRiskLossTypesByRiskScenarioId`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchControlStrength = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRQ_RISK_ENDPOINT_URL}/getcontrolstrength`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const saveRiskScenarioLosses = async (riskData) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_CRQ_RISK_ENDPOINT_URL}/saveriskscenariolosstype`, riskData, {});
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const analysis = async ({ objformdata }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_CRQ_PYTHON_ENDPOINT_URL}/analysis`, objformdata, {});
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};
